import MainNav from "./components/common/MainNav";

window.addEventListener('DOMContentLoaded', () => {
    new MainNav();
});
